export const DeleteLayerGroupModal = () => {
    return null;
};
